/** Canonical assignment strategy binding; tenant and AS_IS checks stay with callers. */
export function orgStateMatchesStrategy(
  orgState: { strategyId?: unknown; orgContextId?: unknown },
  strategy: { id: string; orgContextId?: unknown },
): boolean {
  const orgStrategyId = String(orgState.strategyId ?? '').trim();
  const orgContextId = String(orgState.orgContextId ?? '').trim();
  const strategyOrgContextId = String(strategy.orgContextId ?? '').trim();
  return orgStrategyId === strategy.id ||
    Boolean(!orgStrategyId && orgContextId && strategyOrgContextId && orgContextId === strategyOrgContextId);
}
